import type { Lang } from '@/i18n/locale';
import type { FitnessExerciseReplacementCopy } from '@/i18n/fitnessExperienceTypes';
import { requireFitnessExperienceCopy } from '@/i18n/translations';
export type { FitnessExerciseReplacementCopy } from '@/i18n/fitnessExperienceTypes';

/** Synchronous after the shared locale boot/readiness boundary. */
export const fitnessExerciseReplacementCopy = (lang: Lang): FitnessExerciseReplacementCopy => requireFitnessExperienceCopy(lang, 'replacement');
